import * as React from 'react'
import Tippy from '@tippyjs/react'
import { Transition } from '@headlessui/react'
import { UserIcon } from '@heroicons/react/solid'
import useOnClickOutside from '@/hooks/useOnClickOutside'
import { NavDropDown } from './NavDropDown'
import { IProfileMenu } from './types'

type AccountMenuProps = {
    profileMenu: IProfileMenu
}

export const AccountMenu: React.FC<AccountMenuProps> = ({ profileMenu }) => {
    const [open, setOpen] = React.useState(false)
    const accountMenuRef = React.useRef<HTMLDivElement>(null)

    useOnClickOutside(accountMenuRef, () => setOpen(false))

    return (
        <div className="relative mx-2 mr-6 mt-1" ref={accountMenuRef}>
            <Tippy content={profileMenu.email || 'My Account'}>
                <button
                    onClick={() => setOpen(currentOpen => !currentOpen)}
                    className="flex h-9 w-9 items-center justify-center rounded-full bg-baby-gray-200 p-1 text-baby-gray-50 shadow-md transition duration-300 ease-in-out hover:text-primary focus:outline-none dark:bg-gray-800 dark:text-secondary-100"
                    data-info="account"
                    aria-label={`Account for ${
                        profileMenu.name || 'current user'
                    }`}
                    aria-expanded={open}
                    aria-haspopup="menu"
                >
                    <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-primary text-xs font-semibold text-white">
                        {profileMenu.initials || (
                            <UserIcon className="h-5 w-5" />
                        )}
                    </span>
                </button>
            </Tippy>
            <div className="absolute right-0 mt-3 w-72 overflow-hidden rounded-md bg-white shadow-xl z-10 dark:bg-gray-800">
                {open && (
                    <Transition
                        appear={true}
                        show={open}
                        enter="transition-opacity duration-500 ease-out"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="transition-opacity duration-50 ease-out"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <NavDropDown
                            name={profileMenu.name}
                            email={profileMenu.email}
                            initials={profileMenu.initials}
                            styles={profileMenu.styles}
                            links={profileMenu.links}
                            component={profileMenu.component}
                            onClose={() => setOpen(false)}
                        />
                    </Transition>
                )}
            </div>
        </div>
    )
}
